<template>
  <div>
    <!-- Message Buttn Function Start -->
    <b-breadcrumb-item style="border:5px;" @click="addMessage()"  class="ml-2 mr-2"><b-badge  style="font-size: 100%;color:red;"><b>Notes</b></b-badge></b-breadcrumb-item>
    <!-- <b-button
      style="font-size: 0.505rem"
      class="mt-2"
      size="sm"
      variant="info"
      @click="addMessage()"
    >
      <md-icon>message</md-icon>Note
    </b-button> -->

    <!-- Message Buttn Function End -->
  </div>
</template>


<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation,
} from "../../helper/collection";

export default {
  props: ["fk_all_module_id", "fk_client_id", "fk_pod_id"],
  beforeMount() {},

  data() {
    return {
      allAgentColoaderData: [],
      filterAgent: "",
      //   isLoading: false,
    };
  },
  //this.$route.params.moduleId?this.$route.params.moduleId:
  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    Loading,
    DatePicker,
    ModelListSelect,
  },

  computed: {},
  watch: {
    JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getData();
      },
      deep: true,
    },
  },
  methods: {
    addMessage() {
      let data = {
        jobType: "",
        typeOf: "",
        statusMain: '',
        allMessageId: '',
        allModuleId: this.fk_all_module_id,
        client_id: this.fk_client_id,
        pod_id: this.fk_pod_id,
      };
      this.$sessionsStorage.set("MessageStatus", JSON.stringify(data));
      this.$router.push({
        path: "/UpdateMessage/allMessageForm",
      });
    },
  },
};
</script>
<style>
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>


// WEBPACK FOOTER //
// addMessage.vue?20c4d5f1